module.exports = __webpack_public_path__ + "static/img/detail_right_icon.d7fd2271.svg";